export default [
  {
    id: 1,
    label: "보호구",
    check: false,
    title: "보호구",
    list: [
      {
        id: 1,
        label: "1. 보호구 착용 및 관리상태(청력, 호흡용)가 적절 한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "2. 기타 보호구 착용 및 관리상태가 적절한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "3. 적절한 보호구(적격품)를 지급하고 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 2,
    label: "환기 및 배기장치",
    check: false,
    title: "환기 및 배기장치",
    list: [
      {
        id: 1,
        label: "1. 환기상태 및 환기설비 작동상태는 적절한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "2. 국소 배기장치 상태 및 작동, 관리는 적절한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "3. 밀폐공간 주기적인 점검 및 파악(산소농도, 자연환기, 환기 사용 점검 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 3,
    label: "표지",
    check: false,
    title: "표지",
    list: [
      {
        id: 1,
        label: "1. 안전보건표지는 적절히 부착되어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "2. 산업안전보건법령요지는 눈에 띄는 곳에 게시되 어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "3. 화학물질 취급시 MSDS 게시 및 부착의무, 작업 공정별 관리요령 게시가 이루어져 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 4,
    label: "작업자세",
    check: false,
    title: "작업자세",
    list: [
      {
        id: 1,
        label: "1. 작업자세/동선 및 중량물 취급자세 (중량물 취급시 2인 1조 작업/ 이동보조도구 활 용 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 5,
    label: "작업장",
    check: false,
    title: "작업장",
    list: [
      {
        id: 1,
        label: "1. 작업장 내 정리정돈, 위생상태/ 소화기 유무, 관리 상태 (통로확보, 분리수거함 등)\n",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "2. 시설물 파손여부, 청소, 점검 등 관리상태",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "3. 인화성물질(휘발유, 등유, 경유 등)은 안전하게 관리되고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "4. 화학물질 소분용기에 경고표지가 부착되어 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 6,
    label: "근로자",
    check: false,
    title: "근로자",
    list: [
      {
        id: 1,
        label: "1. 근로자의 부상, 외상 등 조치할 수 있는 응급구급함이 갖추어져 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "2. 근로자의 정기적인 건강진단을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "3. 교대근무 여부",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "4. 근로자의 질병 예방 및 사후관리 방안이 활용되 고 있는가? (휴식시간, 휴게시설, 유연근무제 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 7,
    label: "교육",
    check: false,
    title: "교육",
    list: [
      {
        id: 1,
        label: "1. 매달 정기안전보건교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "2. 신규 근로자의 경우 안전보건교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "3. 근로자의 특별교육 해당일 경우 이를 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "4. MSDS교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 8,
    label: "직업성 질환",
    check: false,
    title: "직업성 질환",
    list: [
      {
        id: 1,
        label: "1. 하루 4시간 이상 집중적으로 자료입력 등을 위한 키보드/마우스 조작작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "2. 하루 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세의 작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "3. 하루 총 2시간 이상 4.5kg이상의 물건을 한 손으 로 들거나 동일한 힘으로 쥐는 작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "4. 5kg이상 중량물 취급 시 중량물 취급안내표시가 부착되어있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        label: "5. 근무시 기타 질환 유발요인들이 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 9,
    label: "휴게시설",
    check: false,
    title: "휴게시설",
    list: [
      {
        id: 1,
        label: "휴게시설은 마련되어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "기준에 적합한가?",
        is_checked: "",
        note: "",
      },
    ],
  },
];
